import * as XLSX from "xlsx-color";
import {EmployeeData, PIMetadata} from "../../api/performanceAPI";

function handleExport(data: EmployeeData[], metadata: PIMetadata) {
  let filteredData = data;
  if (metadata.status === "Completed")
  {
    filteredData =  data.filter(row=>row.approvalLog)
  }
  const excel_data = filteredData.map((row) => ({
    Name: row.FirstName,
    ID: row.EmployeeID,
    Date: row.WorkDate,
    HoursBooked: row.AddedValue,
    Incentive: row.IncentivePercentage,
    CustomerOrStrypes: row.customerOrStrypes,
    Project: row.Project,
    Note: row.Note,
    Manager: row.GM,
    Department: row.DepartmentName,
    Approved: row.approvalLog,
    IsExternal: row.IsInternalEmployee ? "No": "Yes",
  }));
  // Add metadata row
  const metadataRow = [
      ["","Please highlight all Externals with grey", "", "", "", "", "", "", "", "", "End Date:", metadata.generation_time, "Status", metadata.status],
      ["Name",  "ID",  "Date",  "Hours Booked",  "Incentive", "Requested By", "Project","Note",  "Manager",  "Department",  "Approved",  "Is External"]];


  // Convert to worksheet
  // Start with empty worksheet
const worksheet = XLSX.utils.aoa_to_sheet(metadataRow);

// Add metadata to the first row (A1)

  worksheet["!merges"] = [
  { s: { r: 0, c: 1 }, e: { r: 0, c: 7 } }, // A1:B1
];
// Add actual data starting from the second row (A2)
XLSX.utils.sheet_add_json(worksheet, excel_data, { origin: "A3", skipHeader: true });


  // Add metadata on top

  // Set column widths
  worksheet["!cols"] = [
    { wch: 25 }, // Name
    { wch: 15 }, // ID
    { wch: 12 }, // Date
    { wch: 8 }, // HoursBooked
    { wch: 12 }, // Incentive
    { wch: 20 }, // Project
    { wch: 20 }, // Note
    { wch: 25 }, // Manager
    { wch: 10 }, // Department
    { wch: 40 }, // Approved
    { wch: 10 }, // IsExternal
  ];

  // Optional: Highlight externals in grey (SheetJS requires cell-level access)
  const range = XLSX.utils.decode_range(worksheet["!ref"] as string);
  for (let R = 2; R <= range.e.r; ++R) { // skip metadata and header rows
    const cell = worksheet[`L${R + 1}`]; // column J = IsExternal

    if (cell && cell.v === "Yes") {
      for (let C = 0; C <= 14; ++C) {
        const colLetter = XLSX.utils.encode_col(C);
        const targetCell = worksheet[`${colLetter}${R + 1}`];

        if (targetCell)
        {
          targetCell.s = {
            fill: {
              patternType: "solid",
              fgColor: { rgb: "D9D9D9" } // light grey
            }
          };
        }

      }
    }
  }

  // Enable styling (requires SheetJS Pro OR export to .xls format with styling)
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Performance Data");

  XLSX.writeFile(workbook, "performance_incentive.xlsx");
}
export default handleExport;